import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { SyntheticEvent, useMemo } from 'react';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import { borderRadius, isMediaMax } from 'presentations/views/styles';
import { black } from 'presentations/views/styles/color';
import {
  homePath,
  productBookingPath,
  productFormPath,
} from 'presentations/routes/path';
import { setEvent } from 'presentations/views/helpers/analytics';
import Image from 'presentations/views/components/atoms/Image';
import { ProductType } from 'domains/models/blog_post/productType';
import { imagePath } from 'presentations/assets';
import { Amplitude } from 'presentations/views/helpers/analytics/amplitude';

interface Props {
  productType: ProductType;
  position?: 'modal' | 'display';
  isHideClose?: boolean;
  className?: string;
  adId?: string | null;
  name?: string;
}

export function getLandingPageUrl(productType: ProductType) {
  switch (productType) {
    case ProductType.Booking:
      return productBookingPath();
    case ProductType.Form:
      return productFormPath();
    case ProductType.Calendar:
      return homePath();
    // return productCalendarPath();
    default:
      break;
  }
  return homePath();
}

export default function (props: Props) {
  const t = translateInComponent(translations);
  const isMobile = isMediaMax('tablet');
  const targetUrl = useMemo(() => {
    return getLandingPageUrl(props.productType);
  }, [props.productType]);

  const isVideo = useMemo(() => {
    if (!props.adId) return false;
    const texts = props.adId.split('.');
    const ext = texts[texts.length - 1];
    return ext === 'mp4';
  }, [props.adId]);
  const eventName = `click ${props.name || 'resource'} banner`;

  const adImageSize = useMemo(() => {
    if (!props.adId) return { width: 0, height: 0 };
    if (
      ['202310-4.ja.png', '202310-5.ja.png', '202310-6.ja.png'].includes(
        props.adId,
      )
    ) {
      return { width: 350, height: 350 };
    }
    return { width: 350, height: 236 };
  }, [props.adId]);

  const onClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
    setEvent(eventName, {
      position: props.position || 'sub_top',
      contentType: 'image',
      contentId: props.adId,
      isVideo,
    });
    Amplitude.magazineAdClick({
      position: props.position || 'display',
      contentType: 'top',
      contentId: 'image',
      productType: props.productType,
    });
  };
  if (!props.adId) return null;
  return (
    <SubImageAd
      href={targetUrl}
      onClick={onClick}
      withoutNextLink
      target="_blank"
    >
      {isVideo ? (
        <AdVideo
          src={imagePath(`ads/${props.adId}`)}
          width={'100%'}
          autoPlay
          loop
          muted
          playsInline={isMobile}
        />
      ) : (
        <AdImage
          src={`ads/${props.adId}`}
          alt={t('Jicoo')}
          width={adImageSize.width}
          height={adImageSize.height}
          dpr={2}
        />
      )}
    </SubImageAd>
  );
}

const SubImageAd = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${black};
`;

const AdImage = styled(Image)`
  width: 100%;
  height: auto;
`;

const AdVideo = styled.video`
  width: 100%;
  height: auto;
  border-radius: ${borderRadius(6)};
`;
